import React, { Component } from 'react';
import { IProduct, IMe, IPedido } from '../Library/types';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import Layout from './Layout';
import OrderService from '../ApiClients/OrderService';
import Loader from './Material/Loader';
import { getProductDescriptionColor } from '../Library/helpers';
import { withParamsAndNavigate } from './Material/ReactRouter';
import Translate from './Material/Traductor';

const styles = (theme: Theme) => createStyles({
    container: {
        position: 'absolute',
        top: 100,
        left: 0,
        right: 0,
        bottom: 30,
        overflowY: 'auto',
        padding: '10px',
        textAlign: 'center',
    },
    image: {
        maxWidth:'700px',
        width: '100%',
        height: 'auto'
    },
    promotion: {
        //backgroundColor: '#f00',
        padding: '3px 15px',
        //color: '#fff',
        verticalAlign: 'middle',
    },
});

interface IFarmerDetailProps {
    myInfo?: IMe;
    version: string;
    params?:any;
    navigate?:any;
    classes:any;
    pedido: IPedido;
    lang: string;
}

interface IFarmerDetailState {
    product?: IProduct;
    loading: boolean;
}

class FarmerDetail extends Component<IFarmerDetailProps, IFarmerDetailState>  {
    constructor(props: IFarmerDetailProps) {
        super(props);
        this.state = {
            loading: true
        };
    }

    componentDidMount() {
        this.loadProductDetails();
    }

    componentDidUpdate(prevProps: IFarmerDetailProps) {
        if (this.props.params.productRef !== prevProps.params.productRef || this.props.params.dataareaid !== prevProps.params.dataareaid) {
            this.loadProductDetails();
        }
    }

    loadProductDetails = async () => {
        let productRef = this.props.params.productRef;

        let product:IProduct = await OrderService.getProduct(productRef);

        this.setState({ product, loading: false});
    }

    render() {
        const { classes, navigate, pedido, version, myInfo, params, lang } = this.props;

        const { product } = this.state;

        
        if(myInfo == null)
            console.log('Usuario no autorizado');

        let typeProperties : Array<string> = product?getProductDescriptionColor(product.category_sale, lang):['','','']
        const imageB64 = product && product.image?new Buffer(product.image).toString("base64"):'';

        return (
            <div>
               <Layout
                    navigate={navigate}
                    params={params}
                    placeholderSearch={""}
                    badgeAlarms={pedido.cart.length}
                    version={version}
                    searchValue={''}
                    me={myInfo}
                />
                {product && myInfo?
                    <div className={classes.container}>
                        <h3>{product.ITEMNAME}</h3>
                        <div className={classes.promotion} style={{backgroundColor:typeProperties[1], color:typeProperties[2]}}>
                            {typeProperties[0]}
                        </div>
                        <p>{product.name}</p>
                        <img
                            alt='' 
                            src={`${product.uri_img}`}
                            className={classes.image}
                        />
                    </div>
                    :
                        this.state.loading ?
                            <div style={{marginLeft:'50%',marginTop:'50%'}}>
                                <Loader loading={this.state.loading}/>
                            </div>
                        :
                            <div className={classes.container}>
                                <h3>{`${Translate(lang, "label.farmer.detail.01")}`}</h3>
                            </div>
                }
            </div>
        );
    }
}
export default withStyles(styles)(withParamsAndNavigate(FarmerDetail));